import { useIntl } from 'react-intl';

import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';
import { useModalSimple } from '~/ui/hooks/modal';

export const useReassignSignerModal = ({
  handleAssign,
  handleHide,
}: {
  handleAssign: () => void;
  handleHide?: () => void;
}): {
  reassignSignerModal: React.ReactNode;
  showReassignSignerModal: () => void;
} => {
  const intl = useIntl();
  const [reassignSignerModal, showReassignSignerModal] = useModalSimple({
    title: intl.formatMessage({
      id: 'useReassignSignerModal.reassignSignerModalTitle',
      defaultMessage: 'Re-assign signer?',
      description: 'Modal title for reassigning signer',
    }),
    content: (
      <Layout direction="column" spacing={4}>
        <Text variant="body">
          {intl.formatMessage({
            id: 'useReassignSignerModal.reassignSignerWarning',
            defaultMessage:
              'Doing this on a document that was already processed by the e-sig provider can result in mis-matched signer information. To correct this, we will require the signature coordinator to re-collect signatures.',
            description:
              'Warning about reassigning signer on processed documents',
          })}
        </Text>
        <Text variant="body-bold">
          {intl.formatMessage({
            id: 'useReassignSignerModal.signaturesVoidedWarning',
            defaultMessage: 'All signatures will be voided and reset.',
            description: 'Warning that all signatures will be voided',
          })}
        </Text>
      </Layout>
    ),
    confirm: handleAssign,
    onHide: handleHide,
    width: 'm',
    disableAutoHide: false,
    disableCancelButton: false,
    text: intl.formatMessage({
      id: 'useReassignSignerModal.resetAndReassignButton',
      defaultMessage: 'Reset signature & Re-assign',
      description: 'Button text for resetting signature and reassigning',
    }),
  }) as [React.ReactElement, () => void];

  return {
    reassignSignerModal,
    showReassignSignerModal,
  };
};
